var toggleNav = {

	init: function () {
		$('.m-toggle-nav:not(.js-toggle-nav-done)').each(function () {
			var wrapper = $(this);
			var title = wrapper.find('.js-toggle-nav-title');
			var content = wrapper.find('.js-toggle-nav-content');
			var allow = true;

			// load
			if (title.is('.closed')) {
				content.hide();
			}

			// click
			title.off('click').on('click', function () {
				if (!allow) return false;
				allow = false;
				title.toggleClass('closed');
				content.slideToggle(250, function () {
					allow = true;
				});
				return false;
			});

			// sub
			wrapper.find('.js-toggle-nav-sub-title').each(function () {
				var title = $(this);
				var content = title.next('.js-toggle-nav-sub-content:first');
				var allow = true;

				// click
				title.off('click').on('click', function () {
					if (!allow) return false;
					allow = false;
					title.toggleClass('active');
					content.slideToggle(250, function () {
						allow = true;
					});
					return false;
				});

			});

			// done
			wrapper.addClass('js-toggle-nav-done');
		});
	}

};

$(function () {
	toggleNav.init();
	$(document).ajaxComplete(function () {
		toggleNav.init();
	});
});